import { CapoPlugin } from "/build/e8ceee89-7820-4ba0-aefd-fbba564a98c1/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];